<template>
	<div id="benefits" >
		<div class="benefits">
			<div class="benefits_content container">
				<SectionHeader topText="2023 Season Ticket Holder " bottomText="Exclusive Benefits" />
				<div class="exclusive_perks_header">
					<h2>Preferred Access &amp; Offers</h2>
				</div>
				<div class="benefits_section">
					<div class="flip_card" v-for="(perk, i) in Perks" :key="i">
						<flipBox :benefit="perk" />
					</div>
				</div>

			</div>

		</div>
		<div class="benefits">
			<div class="perks_content container">
				<div class="exclusive_perks_header">
					<h2> Exclusive GameDay Experiences</h2>
				</div>
				<div class="benefits_section">
					<div class="flip_card" v-for="(benefit, i) in Benefits" :key="i">
						<flipBox :benefit="benefit" />
					</div>

				</div>

			</div>
		</div>
		<div class="benefits testimonial_video container">
			<!-- <div class=" container"> -->
				<div class="exclusive_perks_header">
					<h2> Season Ticket Holder Testimonials</h2>
				</div>
				<!-- <iframe src="https://player.vimeo.com/video/757310680?h=7fed5f5665" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> -->
				<iframe src="https://www.youtube.com/embed/CdysDBEWnXw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>


			<!-- </div> -->
		</div>


		<!-- <div class=" ">
			<div class="exclusive_perks_header">
				<h2> </h2>
			</div>
		</div> -->
		<divider img_src="first-divider.png" author="Ian Happ" quote=" “Every day, you the fans, show up and give us the best atmosphere in the entire sport. Thank you for your loyalty and dedication! The best is yet to come.” " />

	</div>
</template>

<script>
import SectionHeader from "@/components/SectionHeader";
import divider from "@/components/divider";
import flipBox from "./flipBox";

export default {
	name: "BenefitBottom",
	components: { SectionHeader, divider, flipBox },
	data() {
		return {
			Benefits: [
				{
					id: 0,
					header: "Autograph sessions",
					imgSrc: "experiences_A Auto session.jpg",
					text: "Receive an autograph from a current or former Cub in a Season Ticket Holder-only autograph session.",
				},
				{
					id: 1,
					header: "Kids take the field",
					imgSrc: "experiences_B Kids take the field.jpg",
					text: "Kids take the field and are greeted by Cubs player to receive an autograph (for kids ages 5-13).",

				},
				{
					id: 2,
					header: "Honorary Grounds Crew Member",
					imgSrc: "experiences_C Grounds Crew 1.jpg",
					text: "Prepare the field pregame for your Chicago Cubs with our grounds crew.",
				},
				{
					id: 3,
					header: "Game Ball delivery",
					imgSrc: "experiences_D Game ball delivery.jpg",
					text: "Deliver the game ball to the pitcher’s mound during the pregame festivities.",

				},
				{
					id: 4,
					header: "Play Ball Announcer",
					imgSrc: "experiences_E Play ball.jpg",
					text: 'A child ages 5-13 can call "Play Ball!" during the pregame festivities with video board recognition.',

				},

				{
					id: 5,
					header: "Pregame On-Field Passes",
					imgSrc: "experiences_F Pregame Field Passes.jpg",
					// imgSrc: "F Pregame Field Passes.jpg",
					text: "Come down to the field pregame in an area set up for Season Ticket Holders.",

				},
				{
					id: 6,
					header: "Season Ticket Holder of the game",
					imgSrc: "experiences_G STH Of the Game.jpg",
					text: "Pregame on-field video board recognition presented by Jim Beam.",

				},
				{
					id: 7,
					header: "Postgame photo pass",
					imgSrc: "experiences_H post game photo pass.jpg",
					text: "Take a photo with family/friends on the field after a home game.",

				},
				{
					id: 8,
					header: "Lineup card delivery",
					imgSrc: "experiences_I line up card delivery.jpg",
					text: "Deliver the lineup card to the umpires at home plate during the pregame festivities.",

				},
				{
					id: 9,
					header: "Kids Corral Access",
					imgSrc: "experiences_J Kids corral.jpg",
					text: "Pregame field access for kids 13 and under.",

				},
				{
					id: 10,
					header: "Kids run the bases",
					imgSrc: "experiences_K Kids run the bases.jpg",
					text: "Front of the line access for this fun postgame event after Sunday day games (weather permitting).",
				},
				{
					id: 11,
					header: "Season Ticket Holder parade",
					imgSrc: "experiences_L STH Parade.jpg",
					text: "Participate in a pregame warning track parade with fellow Season Ticket Holders led by Clark the Cub.",
				},
			],
			Perks:[
				{
					id: 0,
					header: "Season Ticket Holder Family Day",
					imgSrc: "perks_A FamDay.jpg",
					text: "Season Ticket Holder Family Day: September 2 and September 3.",
				},
				{
					id: 2,
					header: "Season Ticket Holder Gift",
					imgSrc: "perks_C STH Gift.jpg",
					text: "Exclusive Season Ticket Holder gift.",
				},
				{
					id: 3,
					header: "Cubs Store Merchandise Discount",
					imgSrc: "perks_D merch discount.jpg",
					text: `Receive a 15% discount redeemed via mobile wallet at either the Cubs Store at Gallagher Way or Cubs Store behind home plate. Excluding Authentics items and exclusive Premier Club merchandise.`,
					//  For more information please <a style="color:white !important;" href="https://www.mlb.com/cubs/tickets/season-tickets/holders/benefits/2023" target="_blank">click here.</a>
				},
				{
					id: 4,
					header: "Food and Beverage Discount",
					imgSrc: "perks_E Food and Bev 1.jpg",
					text: `Receive a 15% discount on food and non-alcoholic beverages purchased via the MLB Ballpark app. For more information please <a style="color:white !important;" href="https://www.mlb.com/cubs/tickets/season-tickets/holders/benefits/2023" target="_blank">click here.</a>`,
				},
				{
					id: 5,
					header: "Ticket Exchange Program",
					imgSrc: "perks_F Ticket Exchange Program.jpg",
					text: `Opportunity to return tickets for up to six regular games back for a credit or exchange. For Daily Plan Holders only. For more information please <a style="color:white !important;" href="https://www.mlb.com/cubs/tickets/season-tickets/holders/benefits/2023" target="_blank">click here.</a>`,

					// <a target="_blank" href="https://mpv.tickets.com/?orgid=40490&agency=CBMT_MYTIXX#/auth/login">More Info </a>
				},
				{
					id: 6,
					header: "Access To Postseason Tickets",
					imgSrc: "perks_G PostseasonAccess.jpg",
					text: "Priority access to purchase postseason tickets in advance of the general public.",
				},
				{
					id: 7,
					header: "Dedicated Service Representative",
					imgSrc: "perks_H Dedicated Rep.jpg",
					text: "Receive dedicated Season Ticket Holder service and communications.",
				},
				{
					id: 9,
					header: "Online Seat Relocation Event",
					imgSrc: "perks_J relocation_larger.jpg",
					text: "Opportunity to participate in the annual online Season Ticket Holder Seat Relocation event starting in January 2024.",
				},
				{
					id: 8,
					header: "ACCESS TO TICKET PRESALES",
					imgSrc: "perks_I Single Game Ticket PreSale.jpg",
					text: "Opportunity to participate in presales for Spring Training tickets and regular season ticket offerings.",

				},
				{
					id: 10,
					header: "Free MLB.TV Subscription",
					imgSrc: "perks_K MLB TV.jpg",
					text: `Access to a free standard <a style="color:white !important;" href="https://www.mlb.tv/" target="_blank"/>MLB.TV</a> subscription which includes out-of-market games. Local television territory blackout restrictions apply. Additional details will be shared before the start of the 2023 season.`
					// text: `Access to a free standard MLB.TV subscription (blackout restrictions apply) and an Exclusive online MLBSHOP.com 15% discount available via a unique code sent to you.`,
				},
				{
					id: 11,
					header: "MLBShop.com Discount",
					imgSrc: "perks_MLBShop.jpg",
					// text: `Access to a free standard <a style="color:white !important;" href="https://www.mlb.tv/" target="_blank"/>MLB.TV</a> subscription (blackout restrictions apply) and an exclusive online MLBSHOP.com 15% discount available via a unique code sent to you.`
					text: `Exclusive online MLBSHOP.com 15% discount available via a unique code sent to you.`,
				},
				{
					id: 12,
					header: "Ticket Donation Program",
					imgSrc: "perks_N Donation.jpg",
					text: "Ability to donate your tickets to select charitable organizations.",
				},
			],
		};
	},
	mounted(){

	}
};


</script>

<style lang="scss" scoped>
#benefits{
	// background-color: theme-var($--ch-theme-background-secondary);
	background-image: url("~images/bgImage.jpg");
	background-position:top center;
	// background-repeat: no-repeat;
	background-size:100%;
	@include media-breakpoint-down(sm) {
		background-image: url("~images/bgImage_mobile.jpg");
		// background-size:cover;
	}
	.testimonial_video{
		display: flex;
		flex-direction: column;
		justify-content:center;
		align-items: center;
		// margin-bottom:40px;
		// gap:50px;
		padding: 100px 100px 100px 120px;
		@include media-breakpoint-down(sm) {
			padding: 30px 30px 100px 30px;
		}
		@include media-breakpoint-only(md) {
			padding: 50px 50px 100px 50px;
		}
		iframe{
			width: 1060px;
			height: 537px;
			margin: 40px auto 0px auto;

			box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.6);
			@include media-breakpoint-down(sm) {
				width: 350px;
				height: 200px;
			}
			@include media-breakpoint-only(md) {
				width: 650px;
				height: 370px;
			}
		}
	}
	.exclusive_perks_header{
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: 10px 0px;
		gap: 3px;
		width:100%;
		background: #CC3433;
		h2{
			font-family: 'Verlag Condensed Book';
			font-style: normal;
			font-weight: 400;
			font-size: 25px;
			line-height: 100%;
			text-transform: uppercase;
			color: #FFFFFF;
			margin-bottom: 0px;
			@include media-breakpoint-down(sm) {

				font-size: 18px;
				line-height: 120%;
				padding:0px 10px;
			}
		}
	}
}
.benefits {
	display: flex;
	// background:white;
	position: relative;

	&_content {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		padding:0px;
		 gap: 50px;
		z-index: 1;
		padding: 150px 100px 100px 120px;
		@include media-breakpoint-down(sm) {
			padding: 150px 50px 50px 50px;
		}
		@include media-breakpoint-only(md) {
			padding: 150px 50px 50px 50px;
		}
	}
	.perks_content{
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		padding:0px;
		gap: 50px;
		z-index: 1;
		padding: 0px 100px 100px 120px;
		@include media-breakpoint-down(sm) {
			padding: 50px 50px 100px 50px;
		}
		@include media-breakpoint-only(md) {
			padding: 50px 50px 100px 50px;
		}
	}

	.benefits_section {
	  display: grid;
	  grid-row-gap:30px;
	  width:100%;
	  // grid-column-gap: 10px;
	  // grid-gap: 10px;
	  // @include media-breakpoint-up(xl) {
		  // grid-gap: 20px;
	  // }
	  grid-template-columns: repeat(4, 1fr);
	  align-items: center;
	  justify-content: center;
	  // padding: 10px 60px 60px 60px;

	  @include media-breakpoint-down(sm) {
	    grid-template-columns: repeat(2, 0fr);
		grid-row-gap:0px;
	    // padding:10px;
	  }

	  .flip_card {
	    @include media-breakpoint-down(sm) {
			margin:5px 10px;
	      // display:none;
	    }
		@include media-breakpoint-only(md) {
			margin:15px 10px;
		}
	  }
	}
}

</style>
